import './CEML.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {InputValueCopyTo} from 'extensions/input-value-copy-to';

export default class CEML extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		new InputValueCopyTo();

	}

}
